const color = {
  primary: "#2CBFBF",
  textWhite: "#FFFFFF",
  footer: "#555555",
  footerText: "#ffffff"
}

export default color
